/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Error_Payment_FailedInputs */



/**
* | output |
* | --- |
* | "Your payment method needs updating. Paid models stay unavailable until the payment goes through." |
*
* @param {Chat_Error_Payment_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_error_payment_failed = /** @type {((inputs?: Chat_Error_Payment_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Error_Payment_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Deine Zahlungsmethode muss aktualisiert werden. Kostenpflichtige Modelle sind nicht verfügbar, bis die Zahlung abgeschlossen ist.")
	return /** @type {LocalizedString} */ ("Your payment method needs updating. Paid models stay unavailable until the payment goes through.")
});